"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PortalMountNodeProvider: function() {
        return PortalMountNodeProvider;
    },
    usePortalMountNode: function() {
        return usePortalMountNode;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
/**
 * Provides a mount node for portals to render into.
 *
 * @internal
 */ const PortalMountNodeContext = /*#__PURE__*/ _react.createContext(undefined);
const PortalMountNodeProvider = PortalMountNodeContext.Provider;
function usePortalMountNode() {
    return _react.useContext(PortalMountNodeContext);
}
